import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePatientForm, hasRequiredPersonalInfo } from '../context/PatientFormContext';
import MedicalInfoSection from '../components/form/MedicalInfoSection';
import CycleInfoSection from '../components/form/CycleInfoSection';
import FormHeader from '../components/form/FormHeader';
import { ROUTES } from '../routes';

export default function MedicalInfoPage({ onCancel }) {
  const navigate = useNavigate();
  const [medicalSubstep, setMedicalSubstep] = useState(1);
  const {
    patient,
    form,
    errors,
    setErrors,
    submitting,
    selectedDrugRegimens,
    selectedSideEffects,
    handleChange,
    validateMedicalInfo,
    validateCycleInfo,
    submitForm,
  } = usePatientForm();

  useEffect(() => {
    if (!hasRequiredPersonalInfo(form)) {
      navigate(ROUTES.REGISTER_PERSONAL, { replace: true });
    }
  }, [form, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (medicalSubstep === 1) {
      const err = validateMedicalInfo();

      if (Object.keys(err).length > 0) {
        setErrors(err);
        return;
      }

      setErrors({});
      setMedicalSubstep(2);
      return;
    }

    const cycleErr = validateCycleInfo();

    if (Object.keys(cycleErr).length > 0) {
      setErrors(cycleErr);
      return;
    }

    await submitForm();
  };

  const handleBack = () => {
    if (medicalSubstep === 2) {
      setErrors({});
      setMedicalSubstep(1);
      return;
    }

    navigate(ROUTES.REGISTER_PERSONAL);
  };

  const stepLabel = medicalSubstep === 1
    ? 'Step 2 of 2 — Medical Information'
    : 'Step 2 of 2 — Side Effect Cycles';

  return (
    <section className="form-section">
      <div className="form-card">
        <FormHeader />

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-step-indicator">{stepLabel}</div>

          {medicalSubstep === 1 ? (
            <MedicalInfoSection
              form={form}
              errors={errors}
              selectedDrugRegimens={selectedDrugRegimens}
              selectedSideEffects={selectedSideEffects}
              onChange={handleChange}
            />
          ) : (
            <CycleInfoSection
              form={form}
              errors={errors}
              onChange={handleChange}
            />
          )}

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleBack}
            >
              ← Back
            </button>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {medicalSubstep === 1
                ? 'Next'
                : submitting
                  ? '⏳ Saving...'
                  : patient
                    ? '💾 Save Changes'
                    : '✅ Submit Report'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
